import { h, Fragment, ComponentChildren } from "preact"; /** @jsx h */
import { useLocation } from 'preact-iso';

import { ROUTES } from "@pyqml/shared";

export type ISubscribeTeaserProps = {
    
};

export const SubscribeTeaser = (props: ISubscribeTeaserProps) => {


    const location = useLocation();

    return (
        <div className="border p-5 bg-lightblue">
            <div className="row justify-content-between">
                <div className="col-md-12">
                    <h5 className="font-weight-bold secondfont">Not a member?</h5>
                    Become an expert in using quantum computing for machine learning now.
                </div>
            </div>
            <div className="row gap-y">    
                <div className="col-md-6" >
                    <button className="btn btn-success btn-block" onClick={() => location.route(ROUTES.BLOG_SUBSCRIBE)}>Become A Member</button>
                    
                </div>
            </div>
        </div>


    );
}
  
